import { StyleSheet } from "react-native";

export const _styles = {
  player: StyleSheet.create({
    container: {
      overflow: "hidden",
      backgroundColor: "#000",
      flex: 1,
    },
    video: {
      overflow: "hidden",
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },

    dummy: {
      height: "100%",
      width: "100%",
      top: 0,
      left: 0,
    },
  }),
};
